import { render, staticRenderFns } from "./ModalPageClasse.vue?vue&type=template&id=37300ed6"
import script from "./ModalPageClasse.vue?vue&type=script&lang=js"
export * from "./ModalPageClasse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports